import { render } from "./Visualisations.vue?vue&type=template&id=1e90efa6&ts=true"
import script from "./Visualisations.vue?vue&type=script&lang=ts"
export * from "./Visualisations.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/agnisvegners/projects/anatomynext/a4s-admin-hpc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__